import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { JsonObjectFactoryService } from '../../../shared/_services/json-object-factory.service';

@Injectable({
  providedIn: 'root',
})
export class TemplateAssignService {
  constructor(
    private http: HttpClient,
    private jsonObjectFactory: JsonObjectFactoryService
  ) {}

  getAllTemplates(baseUrl: string, clientKey: string, globalService: any = {}, filterParams: any = {}): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const params = {
      action_id: 31674,
      client_key: clientKey,
    };
    return this.jsonObjectFactory.getJSONObj6(
      url,
      params,
      globalService || {},
      filterParams || {},
      null,
      null
    );
  }

  getTemplateUsers(baseUrl: string, clientKey: string, templateKey: string, globalService: any = {}, filterParams: any = {}): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const params = {
      action_id: 31675,
      client_key: clientKey,
      template_keys: templateKey,
    };
    return this.jsonObjectFactory.getJSONObj6(
      url,
      params,
      globalService || {},
      filterParams || {},
      null,
      null
    );
  }

  getTemplateModules(adminApiUrl: string, clientKey: string, templateKey: string): Observable<any> {
    return this.http.post<any>(
      `${adminApiUrl}/getGtwModules?jurisdiction_key=1&client_key=${clientKey}&row_primary_key=${templateKey}`,
      {},
      { withCredentials: true }
    );
  }

  searchUsers(baseUrl: string, query: string): Observable<any> {
    const fd = new FormData();
    fd.append('action_id', '76');
    fd.append('search_string', query);
    return this.http.post<any>(
      `${baseUrl}/loadJsonObject`,
      fd,
      { withCredentials: true }
    );
  }

  saveModuleAccess(adminApiUrl: string, templateKeys: string, payloadNodes: any[]): Observable<any> {
    const fd = new FormData();
    fd.append('data', JSON.stringify(payloadNodes || []));
    return this.http.post<any>(
      `${adminApiUrl}/setModuleAccess?template_key=${templateKeys}`,
      fd,
      { withCredentials: true }
    );
  }

  saveMultiTemplateUser(baseUrl: string, clientKey: string, globalParams: any, clobData: any, filterParams: any = {}): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=9wru7p`;
    const params = {
      clientKey: clientKey,
      tax_year: globalParams?.tax_year ?? '',
      scenario: globalParams?.scenario ?? '',
      jcd_key: globalParams?.jcd_key ?? '',
      clob_data: JSON.stringify(clobData || {}),
    };
    return this.jsonObjectFactory.saveJSON6(url, params, globalParams || {}, filterParams || {});
  }

  getUserTemplates(baseUrl: string, clientKey: string, userSso: string, globalService: any = {}, filterParams: any = {}): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const params = {
      action_id: 33043,
      client_key: clientKey,
      user_sso: userSso,
    };
    return this.jsonObjectFactory.getJSONObj6(
      url,
      params,
      globalService || {},
      filterParams || {},
      null,
      null
    );
  }

  saveUserTemplates(baseUrl: string, clientKey: string, clobData: any, globalService: any = {}, filterParams: any = {}): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_id=33044`;
    const params = {
      client_key: clientKey,
      clob_data: JSON.stringify(clobData || {}),
    };
    return this.jsonObjectFactory.saveJSON6(url, params, globalService || {}, filterParams || {});
  }
}
